module.exports = __webpack_public_path__ + "static/media/netflix.85910609.svg";